import { render, staticRenderFns } from "./ChapterItem.vue?vue&type=template&id=0d0acc8a&"
import script from "./ChapterItem.vue?vue&type=script&lang=js&"
export * from "./ChapterItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports